export const BANNER_TYPE = ["띠형 배너", "팝업 배너", "이벤트", "푸시알림"];

export const BANNER_ICON = [
  "far fa-bookmark",
  "far fa-window-maximize",
  "far fa-star",
  "far fa-bell"
];

export const BANNER_TYPE_OPTION = [
  { label: "띠형 배너", value: "0" },
  { label: "팝업 배너", value: "1" },
  { label: "이벤트", value: "2" },
  { label: "푸시알림", value: "3" }
];

export const FLOAT_POSITION_LIST = [
  "TOP_LEFT",
  "TOP_CENTER",
  "TOP_RIGHT",
  "BOTTOM_LEFT",
  "BOTTOM_CENTER",
  "BOTTOM_RIGHT"
];

export const FLOAT_POSITION = {
  TOP_LEFT: "top left",
  TOP_CENTER: "top center",
  TOP_RIGHT: "top right",
  BOTTOM_LEFT: "bottom left",
  BOTTOM_CENTER: "bottom center",
  BOTTOM_RIGHT: "bottom right"
};
